import { render, staticRenderFns } from "./HeadquarterCassa.vue?vue&type=template&id=485085b2&"
import script from "./HeadquarterCassa.vue?vue&type=script&lang=ts&"
export * from "./HeadquarterCassa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports